import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyAsJKig6p2b9oTwvJmCw6JbPqEDZk5p-hQ",
  authDomain: "kyewb-796dc.firebaseapp.com",
  databaseURL:
    "https://kyewb-796dc-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "kyewb-796dc",
  storageBucket: "kyewb-796dc.firebasestorage.app",
  messagingSenderId: "453277888227",
  appId: "1:453277888227:web:a10ca6f4babc3670ecdfd6",
  measurementId: "G-3KLFK2QJR3",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const database = getDatabase(app);